import { dataHooks } from '@wix/data-hooks';

export const categoryPageArticleListItemDataHooks = dataHooks<{
  categoryArticleSectionLink;
}>('categoryPageArticleListItem');
